module.exports = __webpack_public_path__ + "static/media/banner-delete.e17e1dbf.png";